import { BoardLayout } from "~/config/andonBoardLayouts/andonLayout.types";

const layouts: BoardLayout[] = [
  {
    name: "UNY4 - Staging",
    dimensions: {
      rows: 9,
      columns: 7
    },
    layout: [
      {
        w: 1,
        h: 1,
        x: 1,
        y: 0,
        i: "4d629497-80ee-41c3-b9c6-d0d8ac8dcdcb",
        maxH: 9,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 5,
        i: "e24731c0-1a3e-44b3-92ca-d51f3ad22f25",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 6,
        i: "5ca6fbd8-1c0f-4294-8a13-4353f39e6587",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 7,
        i: "45c6d659-372b-4830-a729-ea07914e2181",
        maxH: 2,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 8,
        i: "864b74b7-4571-4a21-83ac-32b4f6cf6754",
        maxH: 1,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 4,
        i: "7e440f40-dd72-4897-a0fe-ba1abf8c4618",
        maxH: 5,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 5,
        i: "35d104a0-5e5d-44ff-bd0b-4ee7fa469ed5",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 6,
        i: "24448279-8a25-4daa-8796-290f83323012",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 7,
        i: "1bbfdb37-8409-473b-b472-e8e863044987",
        maxH: 2,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 8,
        i: "6394357f-2a9f-40c8-98cd-89feb9511df0",
        maxH: 1,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 0,
        i: "e04d0f04-bde7-4742-9cac-89a34c3d9e47",
        maxH: 9,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 1,
        i: "07f08ba8-f5d3-4f3c-8f87-34a8f4e8d3db",
        maxH: 8,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 2,
        i: "cadc94fa-b834-4fb2-8621-a1bcbc80714a",
        maxH: 7,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 3,
        i: "b0347821-f6bf-402d-bc5f-39ad2e04e13b",
        maxH: 6,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 4,
        i: "cbfb147f-cebe-45cf-834d-36500fa875b8",
        maxH: 5,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 0,
        i: "7da06320-b73a-4cfa-8b73-8e6afa3e251f",
        maxH: 9,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 1,
        i: "26ed3769-6e4e-4b0a-b774-9423f1804b70",
        maxH: 8,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 2,
        i: "8a415734-c742-4a30-89e5-2552e8366609",
        maxH: 7,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 3,
        i: "3f08b481-e24b-425c-9e5d-a87457a2285d",
        maxH: 6,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 5,
        y: 1,
        i: "924ab68b-dcb1-4e33-9396-d54b435d2120",
        maxH: 8,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 4,
        i: "866c51cf-3158-4b60-b2bd-eece1adebe04",
        maxH: 5,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 6,
        i: "4c3c4df4-b1a7-4814-8fff-315b5fb674ac",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 7,
        i: "a727eb98-8eda-4a31-8033-8263a5d99742",
        maxH: 2,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 5,
        i: "e67f2ca0-e91f-4660-8ac7-f38e3b4b64ad",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 6,
        y: 4,
        i: "38d40272-5b64-4d5f-af6f-f1bba11b422f",
        maxH: 5,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 6,
        y: 5,
        i: "94be7c9c-014f-4267-8f11-4da886dc934f",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 1,
        i: "f928401b-b888-45e4-b9b8-65f9993511f2",
        maxH: 8,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 2,
        i: "908f94fa-50a7-412b-a860-0fa981b2565e",
        maxH: 7,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 3,
        i: "debc672e-0ae7-4b90-9366-0e8f57555183",
        maxH: 6,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 6,
        y: 1,
        i: "4e0dd594-56c9-48b3-b6f6-f39bba91bff9",
        maxH: 8,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 6,
        y: 2,
        i: "d13c25d2-a0b2-4650-9ff7-f9d95087373b",
        maxH: 7,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 6,
        y: 3,
        i: "42fa40ec-2b20-4431-bafb-212424c448be",
        maxH: 6,
        moved: false,
        static: false
      }
    ]
  },
  {
    name: "UNY4 - Staging 2",
    dimensions: {
      rows: 3,
      columns: 6
    },
    layout: [
      {
        w: 1,
        h: 1,
        x: 3,
        y: 1,
        i: "e24731c0-1a3e-44b3-92ca-d51f3ad22f25",
        maxH: 2,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 1,
        i: "5ca6fbd8-1c0f-4294-8a13-4353f39e6587",
        maxH: 2,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 5,
        y: 1,
        i: "45c6d659-372b-4830-a729-ea07914e2181",
        maxH: 2,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 2,
        i: "864b74b7-4571-4a21-83ac-32b4f6cf6754",
        maxH: 1,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 1,
        y: 2,
        i: "7e440f40-dd72-4897-a0fe-ba1abf8c4618",
        maxH: 1,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 2,
        i: "35d104a0-5e5d-44ff-bd0b-4ee7fa469ed5",
        maxH: 1,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 3,
        y: 2,
        i: "24448279-8a25-4daa-8796-290f83323012",
        maxH: 1,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 2,
        i: "1bbfdb37-8409-473b-b472-e8e863044987",
        maxH: 1,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 5,
        y: 2,
        i: "6394357f-2a9f-40c8-98cd-89feb9511df0",
        maxH: 1,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 0,
        i: "e04d0f04-bde7-4742-9cac-89a34c3d9e47",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 1,
        y: 0,
        i: "07f08ba8-f5d3-4f3c-8f87-34a8f4e8d3db",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 0,
        i: "cadc94fa-b834-4fb2-8621-a1bcbc80714a",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 3,
        y: 0,
        i: "b0347821-f6bf-402d-bc5f-39ad2e04e13b",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 0,
        i: "cbfb147f-cebe-45cf-834d-36500fa875b8",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 5,
        y: 0,
        i: "7da06320-b73a-4cfa-8b73-8e6afa3e251f",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 1,
        i: "26ed3769-6e4e-4b0a-b774-9423f1804b70",
        maxH: 2,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 1,
        y: 1,
        i: "8a415734-c742-4a30-89e5-2552e8366609",
        maxH: 2,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 1,
        i: "3f08b481-e24b-425c-9e5d-a87457a2285d",
        maxH: 2,
        moved: false,
        static: false
      }
    ]
  }
];

export default layouts;
